export const REPORT_GET_ALL = "REPORT_GET_ALL";
export const REPORT_GET_ALL_SKILLS = "REPORT_GET_ALL_SKILLS";